import React, { useEffect } from 'react';
import './App.css';
import './assets/styles/bootstrap.min.css';
import './assets/styles/style.css';
import Body from './shared/components/Body/Body';
import * as axios from './core/interceptors/client';
import { ToastContainer,Bounce} from 'react-toastify'; 
import 'react-widgets/dist/css/react-widgets.css';
import 'react-toastify/dist/ReactToastify.css';
import 'axios-progress-bar/dist/nprogress.css';
const axiosProgressBar = require('axios-progress-bar');

const App = (props:any) => {
  
  axiosProgressBar.loadProgressBar({ showSpinner: false }, axios.baseAPI);

  useEffect(() => {
    localStorage.setItem(`${window.location.origin}${window.location.pathname}.timeZoneId`, "49");
  }, [])

return ( 
    <div className="App">
      <Body /> 
      <ToastContainer transition={Bounce} />     
    </div>
  );
}

export default App;
